import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/(container)/analyze/")({
    component: RouteComponent,
    loader: async () => {
        throw redirect({ to: "/games" });
    },
});

function RouteComponent() {
    const navigate = useNavigate();
    useEffect(() => {
        navigate({
            to: "/games",
        });
    }, [navigate]);
    return <div>TODO: implement something?</div>;
}
